export enum LadingPickupType {
    Home = 1,
    PostOffice = 2
}